import { css } from 'emotion';
import snakeCase from 'lodash/snakeCase';
import React from 'react';
import Select, { MenuPlacement } from 'react-select';
import { ActionMeta, ValueType } from 'react-select/src/types';
import { multiSelectStyles } from './MultiSelectStyles';

export interface SelectOption {
  label: string;
  value: string;
}

interface Props {
  id: string;
  isMulti: boolean;
  value?: SelectOption | SelectOption[] | null | undefined;
  className?: string;
  options: SelectOption[];
  menuPlacement: MenuPlacement;
  onChange: (
    selectOptions: ValueType<SelectOption, boolean>,
    actionsMeta: ActionMeta<SelectOption>
  ) => void;
  defaultValue?: ValueType<SelectOption, boolean>;
  components?: any;
  inputId?: string;
  placeholder?: string;
}

class MultiBaseSelect extends React.Component<Props> {
  static defaultProps = {
    isMulti: false,
    menuPlacement: 'auto',
  };

  render(): React.ReactNode {
    const { id, menuPlacement, inputId, placeholder } = this.props;

    return (
      <Select
        styles={multiSelectStyles}
        inputId={inputId}
        placeholder={placeholder}
        components={{
          Option: ({ children, getStyles, innerRef, ...props }) => {
            // NOTE: the use of emotion directly below is required by react-select to do custom styling.
            //       This is an exception to normal styling policies. Emotion should not be used elsewhere.
            const cn = css(getStyles('option', props));
            const val = snakeCase(props.data.value);

            return (
              <div
                ref={innerRef}
                {...props.innerProps}
                className={`${cn} ${id}-option ${id}-option-${val}`}
              >
                {children}
              </div>
            );
          },
          IndicatorsContainer: () => {
            return (
              <div
                id={`${id}-add`}
                className="bgd-primary-blue b-radius-3 mr2 p2 pos-a cursor-pointer"
                style={{
                  marginTop: '1.75rem',
                  bottom: '0.5rem',
                  right: '0rem',
                  width: '40px',
                  height: '40px',
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="#FAFBFC"
                    d="M19.505 11.286h-6.791V4.5c-.016-.388-.33-.69-.714-.69l-.078.004c-.358.039-.636.342-.636.71v6.76l-6.785.001c-.388.016-.69.33-.69.714 0 .383.302.698.684.714h6.791v6.785c.016.388.33.69.714.69l.078-.004c.358-.039.636-.342.636-.71v-6.761H19.5c.388-.016.69-.33.69-.714 0-.383-.302-.698-.684-.714z"
                  />
                </svg>
              </div>
            );
          },
        }}
        {...this.props}
        menuPlacement={menuPlacement}
      />
    );
  }
}

export default MultiBaseSelect;
